fbm.add("commands/connect", ["util/io", "util/screens", "util/pause"], function (uio, uscreens, upause) {

    let {
        link,
        type,
        clear,
        isTypingEnabled,
        enableTyping,
        pause,
        clearKey,
        el,
        eamint
    } = {
        ...uio,
        ...uscreens,
        ...upause,
    }

    let initialized = false;
    let mintPassword = "";
    let maxQty = 1;

    async function isConnected() {
        return await window.dazeth.IsConnected();
    }

    function isInitialized() {
        return initialized;
    }

    function setMaxQty(qty) {
        maxQty = qty;
    }

    function getMaxQty() {
        return maxQty;
    }

    async function power(pOn = true) {
        if (pOn) {
            return on();
        } else {
            return off();
        }
    }

    async function welcome() {
        await clear();

        let now = new Date();
        let tod = "morning";
        if (now.getHours() > 18) {
            tod = "evening"
        } else if (now.getHours() > 12) {
            tod = "afternoon";
        }
        await type(`Good ${tod} Mr. Viepe, how are you today?`);
    }

    async function off(mintMore = null) {
        await type(["\n\n!! WARNING !! ARTIFACT POWER LOSS DETECTED\n\n", `Security shutdown enforced`, `Dumping session garbage files`, `Restoring main security grid`, `Generating New Splines`, `Disconnecting`, `\n\n`], {
            lineWait: 200,
        });
        await type("SESSION ENDED\n\n", {wait: 50});

        if (twttr && twttr.widgets) {
            let scr = document.querySelector(".terminal");
            let at = el('a', scr, 'twitter-share-button', { href: 'https://twitter.com/share?ref_src=twsrc%5Etfw&url=https://fightbackapes.daz3d.com&hashtags=fightbackapes,daz3d,nft&text=Fight Back Apes'});
            at.innerText = "Tweet"
            at.style.display = "none";
            await type([at], { processChars: false});
            twttr.widgets.load().then(() => {
                at.style.display = "";
            });
        }

        let d = null;
        if (mintMore) {
            d = mintMore;
        } else {
            d = link("javascript:location.reload()", {
                text: "Reboot",
                pre: "🖱 ",
                target: "",
            });
        }

        let a = link("https://fightbackapes.daz3d.com", {
            text: "Return to Fight Back Apes",
            pre: "🖱 ",
            target: "_top",
        });
        await type([d, a], {processChars: false});

        await type("\nGood-bye!\n\n", {wait: 100});
    }

    async function on() {

        const prom = async resolve => {
            const f = async function () {
                document.removeEventListener("dazEthInit", f);
                initialized = true;
                await clear();
                resolve();
            }
            document.addEventListener("dazEthInit", f);
        };

        if (await isConnected()) {
            if (!initialized) {

                return new Promise((resolve, reject) => {
                    document.addEventListener("dazEthError", async e => {
                        if (e.detail.error === "wrong-network") {
                            await type("Communication with terminal could not be established");
                            let mm = link("javascript:", {
                                text: "Change to Ethereum " + window.fbaConfig.network + " Network",
                                pre: "🖱 ",
                                click: () => {
                                    window.dazeth.ChangeToChain()
                                }
                            });
                            await type([mm], {processChars:false});
                        }
                        if (e.detail.error === "chain-changed") {
                            await clear();
                            enableTyping(false);
                            await pause(1);
                            enableTyping(true);
                            await type("reboot required");
                            let mm = link("javascript:", {
                                text: "REBOOT",
                                pre: "🖱 ",
                                click: () => {
                                    document.location.reload()
                                }
                            });
                            let a = link("https://fightbackapes.daz3d.com", {
                                text: "Return to Fight Back Apes",
                                pre: "🖱 ",
                                target: "_top",
                            });
                            await type([mm, a], {processChars:false});
                            await type("\nGood-bye!\n\n", {wait: 100});
                            enableTyping(false);
                        }
                    });
                    window.dazeth.Init();
                    return prom(resolve);
                });

            }
            return;
        }

        let mm = link("javascript:", {
            text: "Connect Using Metamask / Coinbase",
            pre: "🖱 ",
            click: () => {
                window.dazeth.InitBrowser()
            }
        });

        let wc = link("javascript:", {
            pre: "🖱 ",
            text: "Connect Using Wallet Connect",
            click: () => {
                window.dazeth.InitWalletConnect()
            }
        });

        await type(["Boot device not found", "Please connect your wallet to continue.\n"]);
        await type([mm, wc], {processChars: false});

        document.addEventListener("dazEthError", async e => {
            if (e.detail.error === "no-account") {
                await type("Communication with terminal could not be established");
                reject("no-account");
            }
            if (e.detail.error === "no-wallet") {
                await type(["No suitable interface with terminal could be established.", "Please check your Eth Wallet and try again."]);
                reject("no-wallet");
            }
            if (e.detail.error === "chain-changed") {
                await type("Communication with terminal was interrupted");
                reject("chain-changed");
            }

        });

        return new Promise(prom);
    }

    async function connect(args) {

        return power(true);
    }

    return {
        power,
        isConnected,
        isInitialized,
        setMaxQty,
        getMaxQty,
        welcome,
        off,
        default: connect
    };
});
